exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".usage-route .exempt-section {\n  background-color: #43ac6a;\n  color: white; }\n\n.usage-route .data-section {\n  padding-right: 0;\n  max-height: 800px;\n  overflow-y: scroll; }\n", ""]);

// exports
